"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("./client");
module.exports = new client_1.IntegrationAppClient({});
//# sourceMappingURL=bundle-index.js.map